import { render, staticRenderFns } from "./IntranetTrainingRequestPage.vue?vue&type=template&id=7cb90692&"
import script from "./IntranetTrainingRequestPage.vue?vue&type=script&lang=js&"
export * from "./IntranetTrainingRequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports